import { ImageWithFallback as Image } from '@/components/common/image-with-fallback'
import { ImageHelper } from '@/lib/helpers/image.helper'

export interface PickleballFeatureCardData {
  image: string
  title: string
  description: string
}

export const PickleballFeatureCard = ({
  image,
  title,
  description,
}: PickleballFeatureCardData) => {
  return (
    <div className='relative aspect-[435/558] overflow-hidden rounded-2xl'>
      <Image
        src={ImageHelper.getImageUrlCdn(image)}
        alt={title}
        fill
        className='h-full w-full object-cover'
      />
      <div className='absolute bottom-0 left-0 flex h-1/2 w-full flex-col justify-end bg-gradient-to-t from-black/70 to-transparent p-5 pb-6 text-white'>
        <h3 className='font-criteria text-xl font-medium uppercase md:text-2xl'>
          {title}
        </h3>
        <p className='mt-1 text-sm text-white/90 md:text-base'>
          {description}
        </p>
      </div>
    </div>
  )
}
